var React = require('react');

function CaretDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.66025 10L17.3205 0H0L8.66025 10Z"}));
}

CaretDownInline.defaultProps = {"width":"18","height":"10","viewBox":"0 0 18 10"};

module.exports = CaretDownInline;

CaretDownInline.default = CaretDownInline;
